module.exports = __webpack_public_path__ + "static/img/Sum.417bef2e.png";